<div class="body-wrapper" *ngIf="!state && !isLoading">
    <div class="box-info">
        <img src="assets/img/alert-icon.png" class="icon-info" />
        <span class="title-alert">{{ "attention" | translate }}<br></span>
        {{ "attention_content" | translate }}
    </div>

    <div class="content">
        <p class="title">{{ "ioh_user_consent" | translate }}</p>
        <p class="subtitle">{{ "verify_number" | translate }}</p>
        <form [formGroup]="loginForm">
            <div class="row">
                <div class="col-12">
                    <label class="labeltext">{{ "msisdn_number" | translate}}</label>
                </div>
                <div class="col-12">
                    <div class="input-box">
                        <span class="prefix">+62</span>
                        <input type="text" formControlName="msisdn" numbersOnly (keyup)="setChildMsisdn()"
                            maxlength="13">
                    </div>

                    <div *ngIf="submitted && f.msisdn.errors" class="invalid-feedback d-block">
                        {{ "error.msisdn_required" | translate}}
                    </div>
                    <div *ngIf="!f.msisdn.errors && validationNo" class="invalid-feedback d-block">
                        {{ "error.msisdn_format" | translate}}
                    </div>
                    <div *ngIf="!f.msisdn.errors && validationMsisdnLength && !validationNo"
                        class="invalid-feedback d-block">
                        {{ "error.msisdn_length" | translate}}
                    </div>
                </div>
                <!-- <div class="col-12">
                    <label class="labeltext">{{ "nik" | translate}}</label>
                </div>
                <div class="col-12">
                    <input type="text" class="input-form" formControlName="nik" numbersOnly (keyup)="checkNik()"
                        placeholder=" {{ 'placeholder_nik' | translate}}" numbersOnly maxlength="16">

                    <div *ngIf="submitted && f.nik.errors" class="invalid-feedback d-block">
                        {{ "error.nik_required" | translate}}
                    </div>
                    <div *ngIf="!f.nik.errors && validationNikFormat" class="invalid-feedback d-block">
                        {{ "error.nik_format" | translate}}
                    </div>
                    <div *ngIf="!f.nik.errors && validationNikLength && !validationNikFormat"
                        class="invalid-feedback d-block">
                        {{ "error.nik_length" | translate}}
                    </div>
                </div> -->
                <div class="col-12">
                    <button class="btn-login" [ngClass]="{ 'disabled' : formDisabled()   }" type="button"
                        (click)="login()">
                        {{ "continue" | translate}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
<app-loading *ngIf="isLoading"></app-loading>


<div class="body-wrapper" *ngIf="state">
    <app-otp [msisdn]="f.msisdn.value" [msisdnType]="msisdnType" (cancelAction)="resetState()"
        [isAutoLogin]="isAutoLogin"></app-otp>
</div>